
import Vue from 'vue';
import { TransformedEmIframe } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedEmIframe['data'],
      required: true,
    },
  },
});
